import { ComponentProps, FC } from 'react'

import { Image } from 'components/image'
import { TeamPerson } from 'api/strapi/teams/types'
import { cn } from 'utils'

import styles from './team-member-avatar.module.css'

export interface TeamMemberAvatarProps extends Omit<ComponentProps<typeof Image>, 'alt'> {
  person: Pick<TeamPerson, 'photo' | 'full_name'>
}

export const TeamMemberAvatar: FC<TeamMemberAvatarProps> = ({ person, className, ...props }) => {
  return (
    <Image
      item={person.photo}
      quality={90}
      alt={person.full_name}
      className={cn(styles.photo, className)}
      {...props}
    />
  )
}
